import React from "react"
import { Loader, ImageProps } from "semantic-ui-react"

// Native lazy loading: the browser only downloads the thumbnails of the visible rows, uses its HTTP cache (the
// image proxy sends cache headers) and cancels requests for rows that disappear. The former version fetched
// every thumbnail of the page immediately, kept an object URL per image without revoking it and showed an
// endless spinner on error (FE-PERF-R08/F14).
const LazyImage = (props: ImageProps) => {
  const { src, size, ...remaining } = props
  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => {
    setLoading(true)
  }, [src])

  const handleDone = () => setLoading(false)

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {loading && (
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundColor: "white",
          }}
        >
          <Loader active inline="centered" size={size} />
        </div>
      )}
      <img
        {...remaining}
        alt={"Error"}
        src={src}
        loading="lazy"
        decoding="async"
        onLoad={handleDone}
        onError={handleDone}
      />
    </div>
  )
}

export default LazyImage
